/**
 * Single source-of-truth for the User Guide / Booklet / FAQ revision
 * number. Import this into any page that renders the docs so the badge
 * stays consistent across the app.
 *
 * Bump `VERSION` whenever we ship documentation-worthy updates.
 */

export const APP_REVISION = {
  version: 'R7',
  revisionCode: '2026.02.R7',
  releasedOn: '12 Feb 2026',
  headline: 'Part Invoicing per Quotation & per Project',
  highlights: [
    'Part Invoicing per Quotation — Approved % per line, cumulative-% capped at 100, INV-XXXX-1/-2/-3 numbering',
    'Part Invoicing per Project — invoice-driven flow, Original Qty & Rate + Approved Qty per line, autosave + draft recovery, deviation audit trail on later rounds',
    'Full accounting wiring — balanced Journal Entry on approval, appears on Statement of Account with correct debit + running balance, exposed on Invoice list with is_part_invoice / part_sequence / base_invoice_number',
    'Credit & Debit Notes module (sales + purchase) integrated into Statement of Accounts',
    'Quotation → Invoice conversion preview carries over advance vouchers without duplication',
    'Corporate Tax page crash fixed (schema mismatch on financials vs income_statement)',
    'Global UX polish — 0-qty and 0-rate line items allowed, scroll-wheel on number inputs disabled, spinner arrows removed',
    'Invoice-Quotation manual linking + Unlink action, legacy "sent" status normaliser',
  ],
};

// Convenient URL builders for QR-code targets. Uses the deployed backend so
// the QR keeps working from any device.
export function buildUserGuidePdfUrl() {
  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  return `${base}/api/public/user-guide/pdf`;
}

export default APP_REVISION;
